import { Tag } from "primereact/tag";

import { Outcome } from "../../../utils/dispatchOutcome";

interface Presentation {
  label: string;
  severity: "success" | "warning" | "danger";
  icon: string;
}

const PRESENTATION: Record<Outcome, Presentation> = {
  delivered: { label: "Delivered", severity: "success", icon: "pi pi-check" },
  withheld: { label: "Withheld by recipient", severity: "warning", icon: "pi pi-ban" },
  undelivered: { label: "Not delivered", severity: "danger", icon: "pi pi-times" },
};

interface OutcomeTagProps {
  outcome: Outcome;
  reason?: string | null;
}

/**
 * States an outcome in words as well as colour, so it survives a colour-blind
 * reader and a screenshot pasted into a ticket. Any reason is shown verbatim.
 */
const OutcomeTag = ({ outcome, reason = null }: OutcomeTagProps) => {
  const { label, severity, icon } = PRESENTATION[outcome];

  return (
    <div className="flex flex-column gap-1" data-testid={`outcome-${outcome}`}>
      <Tag value={label} severity={severity} icon={icon} />
      {reason && <span className="text-xs text-color-secondary">{reason}</span>}
    </div>
  );
};

export default OutcomeTag;
